module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-data', {
    attrs: {
      "url": "api/homepages/1",
      "method": "PUT",
      "form": _vm.form
    },
    on: {
      "success": _vm.onSubmitSuccess
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d3dc46","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homepage.vue
// module id = 445
// module chunks = 1